// Split line items plugin.

bq.splitLine = function(element, options) {
  this.$element  = $(element);
};

bq.splitLine.DEFAULTS = {}

bq.splitLine.prototype = {

  init: function() {
    bq.debug.log("splitLine : init()", this.$element);

    var $el = this.$element,
      useDecimalQty = !!$el.find('[data-original-quantity]').data('quantity-decimal'),
      origQuantity = useDecimalQty ? parseFloat($el.find('[data-original-quantity]').data('original-quantity')) : parseInt($el.find('[data-original-quantity]').data('original-quantity')),
      origId = parseInt($el.find('[data-original-id]').data('original-id')),
      $saveBtn = $el.parents('[data-form-container]').find('[data-line-action-save]'),
      numOfLines = 1,
      disablePrefill = false,
      globalMaxPrecision = parseInt(bq.global.maxLengths.quantityPrecision),
      $documentWizElement = $('[data-bq="document-wizard"]');

    var updateHintedValues = function () {
      var qtyFirst,
          quantEach = origQuantity / numOfLines,
          quantEachStr = quantEach+'';
      if (!Number.isInteger(quantEach)) {
        var integerLength = (quantEachStr).split(".")[0].length,
            quantEachPrecision = quantEachStr.split(".")[1].length,
            precision = (quantEachPrecision < globalMaxPrecision)
              ? quantEachPrecision
              : globalMaxPrecision;
        quantEach = parseFloat(quantEach.toPrecision(integerLength + precision));
        qtyFirst = parseFloat((quantEach + (origQuantity - (quantEach * numOfLines))).toPrecision(integerLength + precision));
      } else {
        qtyFirst = quantEach + (origQuantity - (quantEach * numOfLines));
      }
      $el.find('input[type="text"]').each(function (i, inp) {
        if (i == 0) {
          inp.value = qtyFirst;
        } else {
          inp.value = quantEach;
        }
      });
    }

    var reCheckSum = function () {
      var quantity = [],
          summaryQuantity = 0;

      $el.find('input[type="text"]').each(function (i, inp) {
        summaryQuantity += useDecimalQty ? parseFloat(inp.value) : parseInt(inp.value);
        quantity[i]= useDecimalQty ? parseFloat(inp.value) : parseInt(inp.value);
      });

      if (Math.abs((parseFloat(summaryQuantity.toFixed(globalMaxPrecision)) - origQuantity)) > Number.EPSILON || quantity.indexOf(0) >= 0){
        $saveBtn.attr('disabled', 'disabled');
      } else {
        $saveBtn.removeAttr('disabled');
      }
    }

    $el.find('[data-original-quantity]').val(origQuantity);
    $saveBtn.attr('disabled', 'disabled');
    $el.on('click', '.trigger-new-split-line', function (e) {

      $el
        .find('[data-split-form-lines]')
        .append(
            '<div class="form-group onepage-item-split-row">' +
              '<input type="text" ' +
                'class="form-control onepage-item-split-input onepage-item-split-add" ' +
                'name="split_items[' + origId + '][]" ' +
                'id="split_items[' + origId + '][]" ' +
                'data-validate-qty-input="true" ' +
                'data-validate-type="'+ (useDecimalQty ? "number" : "integer") + '" ' +
                'maxlength="'+bq.global.maxLengths.quantityInput+'"' +
              '>' +
              '<label class="control-label sr-only">New Line</label>' +
            '</div>'
        )
        .addClass('unsaved-line-action');

      numOfLines++;

      if (!disablePrefill) {
        updateHintedValues();
      }
      reCheckSum();

      if (numOfLines == origQuantity) {
        $el.find('.trigger-new-split-line').hide();
      }
      e.preventDefault();
    });

    $el.on('focus', 'input[type="text"]', function () {
      reCheckSum();
    });

    $el.on('change', 'input[type="text"]', function (e) {
      disablePrefill = true;
      if ($(this).hasClass('onepage-item-split-add') && ($(this).val() == 0)) {
        numOfLines--;
        if (numOfLines > 1) {
          $(this).parent('.onepage-item-split-row').remove();
          $el.find('.trigger-new-split-line').show();
        }
      }

      reCheckSum();

      if (!$el.find('[data-original-quantity]')[0].value) {
        $saveBtn.attr('disabled', 'disabled');
      }
    });

    $saveBtn.on('click', function(e){
      var $this = $(this),
          $form = $this.parents('[data-form-container]');
      if($('[data-onepage-init]').length) {
        $form.find('.onepage-item-split-input').each(function (i, inp) {
          var el = $(inp);
          if (!bq.global.parsley.validationEnabled(el)) {
            bq.global.parsley.setupSingle(el);
          }
          bq.global.parsley.validate(el);
        });
        $form.removeClass('unsaved-line-action');
        $form.find('.unsaved-line-action').removeClass('unsaved-line-action');
        return;
      }

      var formData = $form.find('input, select, textarea').serialize();

      bq.helper.throwEvent('bq.documentwizard.lineactionsave', $documentWizElement, {
        form: $form,
        formData: formData,
        url: $this.data('ajax-url'),
        clickedEl: $this
      });

      $form.find('.unsaved-line-action').removeClass('unsaved-line-action');
      e.preventDefault();
    });

    $('[data-line-action-cancel]').click(function(e) {
      var dataContainer = $(this).data('container');
      if (typeof( dataContainer ) != "undefined") {
        $(dataContainer)
          .removeClass('active')
          .find('.unsaved-line-action')
          .removeClass('unsaved-line-action');

      }
      e.preventDefault();
    });
  }
};


// splitLine PLUGIN DEFINITION
// =======================

var splitLineold = $.fn.splitLine;

$.fn.splitLine = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.splitLine');
    var options = $.extend({}, bq.splitLine.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.splitLine', (data = new bq.splitLine(this, options))); }
    data.init();
  });
};

$.fn.splitLine.Constructor = bq.splitLine;

// splitLine NO CONFLICT
// =================

$.fn.splitLine.noConflict = function () {
  $.fn.splitLine = splitLineold;
  return this;
};

// splitLine DATA-API
// ==============

bq.splitLineInit = function() {
  $('[data-split-form]').each(function () {
    var el = $(this);
    if(el.data('bq.splitLine')) { return; }
    el.splitLine(el.data());
  });
};

bq.init.push(bq.splitLineInit);